import { useQuery } from '@tanstack/react-query';
import { queryKeyFactory } from 'utils/query-client';
import { loaders } from './alternatives.loaders';
import { converters } from './alternatives.converters';
import {
  AlternativeEmployeesFilters,
  AlternativesFilters,
} from './alternatives.types';

export const alternativesKeys = queryKeyFactory('alternatives');

export const useAlternatives = (filters: Partial<AlternativesFilters> = {}) => {
  return useQuery({
    queryKey: alternativesKeys.list(filters),
    queryFn: () => loaders.getAlternatives({ filters }),
    select: converters.getAlternatives,
    keepPreviousData: true,
  });
};

export const useAlternative = (alternativeId: string) => {
  return useQuery({
    queryKey: alternativesKeys.detail(alternativeId),
    queryFn: () => loaders.getAlternative({ alternativeId }),
    select: converters.getAlternative,
    enabled: !!alternativeId,
  });
};

export const useAlternativeContent = (alternativeId: string) => {
  return useQuery({
    queryKey: alternativesKeys.detail('content', alternativeId),
    queryFn: () => loaders.getAlternativeContent({ alternativeId }),
    select: converters.getAlternativeContent,
    enabled: !!alternativeId,
  });
};

export const useAlternativeBenefits = (alternativeId: string) => {
  return useQuery({
    queryKey: alternativesKeys.detail(alternativeId, 'benefits'),
    queryFn: () => loaders.getAlternativeBenefits({ alternativeId }),
    select: converters.getAlternativeBenefits,
    enabled: !!alternativeId,
  });
};
export const useAlternativeEmployees = (
  alternativeId: string,
  filters: Partial<AlternativeEmployeesFilters> = {},
) => {
  return useQuery({
    queryKey: alternativesKeys.list(alternativeId, 'employees', filters),
    queryFn: () => loaders.getEmployees({ alternativeId, filters }),
    select: converters.getAlternativeEmployees,
    enabled: !!alternativeId,
  });
};

export const useAlternativeEmployeesGroups = (alternativeId: string) => {
  return useQuery({
    queryKey: alternativesKeys.list(alternativeId, 'employees-groups'),
    queryFn: () => loaders.getEmployeesGroups({ alternativeId }),
    select: converters.getEmployeesGroups,
    enabled: !!alternativeId,
  });
};
